export default {
    mailBaseData: 'Daten',
    mailActivities: 'Historie',
}